import HighlightedTipsBlock from './HighlightedTipsBlock'
import HighlightedTipsCardBlock from './HighlightedTipsCardBlock'

export { HighlightedTipsBlock, HighlightedTipsCardBlock }
